import { createFileRoute } from "@tanstack/react-router"
import { ImageTransformerScreenWrapper } from "./-ImageTransformerPage"

export const Route = createFileRoute("/tools/image-transformer")({
  component: ImageTransformerScreenWrapper,
})
